import React from "react";
import { Typography } from "@mui/material";

import { StyledMenu, StyledMenuItem } from "./styles";

const HubHookFormSearchResults = ({
  width,
  options = [],
  onSelect = () => {},
  RenderOption,
}) => {
  const hasResults = !!options?.length;

  return (
    <StyledMenu width={width} className="HubSearch-Results">
      {hasResults ? (
        options?.map((op) => (
          <StyledMenuItem onClick={() => onSelect(op)} key={op?.id}>
            {RenderOption ? (
              <RenderOption {...op} />
            ) : (
              <Typography sx={{ fontSize: 12 }}>{op?.label}</Typography>
            )}
          </StyledMenuItem>
        ))
      ) : (
        <StyledMenuItem>
          <Typography sx={{ fontSize: 12 }}>No Option</Typography>
        </StyledMenuItem>
      )}
    </StyledMenu>
  );
};

export default HubHookFormSearchResults;
